import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import {
  ExclamationTriangleIcon,
  LinkSlashIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';
import { TOKEN_STATUS } from './tokenStatusCopy';
import styles from '../../styles/common/tokenStatusView.module.scss';

const STATUS_ICONS = {
  missing: LinkSlashIcon,
  invalid: LinkSlashIcon,
  expired: ClockIcon,
};

export default function TokenStatusView({
  status,
  title,
  description,
  primaryAction,
  secondaryAction,
}) {
  const copy = TOKEN_STATUS[status] || TOKEN_STATUS.invalid;
  const Icon = STATUS_ICONS[status] || ExclamationTriangleIcon;

  return (
    <Box className={styles.container} role="alert">
      <Box className={styles.iconWrap} aria-hidden="true">
        <Icon className={styles.icon} />
      </Box>
      <Typography variant="h5" component="h1" className={styles.title}>
        {title || copy.title}
      </Typography>
      <Typography variant="body1" className={styles.description}>
        {description || copy.description}
      </Typography>
      {primaryAction ? (
        <Button
          variant="primaryBtn"
          fullWidth
          onClick={primaryAction.onClick}
          className={styles.primaryButton}
        >
          {primaryAction.label}
        </Button>
      ) : null}
      {secondaryAction ? (
        <Button
          variant="text"
          fullWidth
          onClick={secondaryAction.onClick}
          className={styles.secondaryButton}
        >
          {secondaryAction.label}
        </Button>
      ) : null}
    </Box>
  );
}
